export const PAYMENT_ERROR_MESSAGE = 'Payment failed, please try again'
export const PAYMENT_SUCCESS_MESSAGE = 'Payment Successful'
export const BILLING_ERROR_MESSAGE = 'Unable to update Billing Information'
export const BILLING_SUCCESS_MESSAGE = 'Successfully updated Billing Information'
